import React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'clsx';
import { ModalContent } from 'fronton-react';
import { css } from 'linaria';
import {
  ButtonWithGAClickButton,
  List,
  ModalContentAction,
  ModalHeader,
  Typography,
} from 'common/components';
import { STORAGE_DESIGN_SIGN_UP_HREF, STORAGE_ELEMENT_BLOCK } from '../../../../storage-constants';

const servicesModalText = css`
  margin-bottom: 8px;
`;

const servicesModalListText = css`
  margin-bottom: 4px;
`;

const servicesModalList = css`
  li:not(:last-child) {
    margin-bottom: 4px;
  }
`;

type ServicesModalProps = {
  regionId: string;
};

export const ServicesModal = ({ regionId }: ServicesModalProps) => {
  const { t } = useTranslation();
  return (
    <>
      <ModalHeader title={t('utp-section.services.card-title')} />
      <ModalContent>
        <Typography className={servicesModalText} variant="m" size="body_long">
          {t('utp-section.services.modal-description-first')}
        </Typography>
        <Typography className={servicesModalListText} variant="m" size="body_long">
          {t('utp-section.services.modal-description-second')}
        </Typography>
        <List className={cn(servicesModalList, servicesModalText)} listStyle="disc">
          <li>
            <Typography variant="m" size="body_long">
              {t('utp-section.services.modal-item-first')}
            </Typography>
          </li>
          <li>
            <Typography variant="m" size="body_long">
              {t('utp-section.services.modal-item-second')}
            </Typography>
          </li>
          <li>
            <Typography variant="m" size="body_long">
              {t('utp-section.services.modal-item-third')}
            </Typography>
          </li>
          <li>
            <Typography variant="m" size="body_long">
              {t('utp-section.services.modal-item-fourth')}
            </Typography>
          </li>
          <li>
            <Typography variant="m" size="body_long">
              {t('utp-section.services.modal-item-fifth')}
            </Typography>
          </li>
          <li>
            <Typography variant="m" size="body_long">
              {t('utp-section.services.modal-item-sixth')}
            </Typography>
          </li>
          <li>
            <Typography variant="m" size="body_long">
              {t('utp-section.services.modal-item-seventh')}
            </Typography>
          </li>
        </List>
        <Typography variant="m" size="body_long">
          {t('utp-section.services.modal-description-third')}
        </Typography>
        <ModalContentAction>
          <ButtonWithGAClickButton
            adaptive={false}
            elementBlock={STORAGE_ELEMENT_BLOCK}
            elementName={t('utp-section.services.card-title')}
            elementText={t('design-panel.button-second')}
            href={`${STORAGE_DESIGN_SIGN_UP_HREF}${regionId}`}
            target="_blank"
            wide>
            {t('design-panel.button-second')}
          </ButtonWithGAClickButton>
        </ModalContentAction>
      </ModalContent>
    </>
  );
};
